<template>
  <div class="main">
    <div class="questionDiv" >
      <div class="title">
        科创板
        <!-- <img class="toggleImg" src="images/3.0/more.png"> -->
      </div>
      <div class="question"  @click="goDetail(1)">如何开通科创板</div>
      <div class="question" @click="goDetail(2)">科创板的开通条件有哪些</div>
      <div class="question" @click="goDetail(3)">科创板的交易规则是什么</div>
    </div>

    <div class="questionDiv" >
      <div class="title">
        开户
        <!-- <img class="toggleImg" src="images/3.0/more.png"> -->
      </div>
      <div class="question"  @click="goDetail(4)">如何在五矿证券开户</div>
      <div class="question" @click="goDetail(5)">已满三户，还能开户吗</div>
      <div class="question" @click="goDetail(6)">自助开户成功后多久可以交易</div>
    </div>

    <div class="questionDiv" >
      <div class="title">
        权限
        <!-- <img class="toggleImg" src="images/3.0/more.png"> -->
      </div>
      <div class="question"  @click="goDetail(7)">如何开通港股通交易权限</div>
      <div class="question" @click="goDetail(8)">如何开通风险警示板交易权限</div>
      <div class="question" @click="goDetail(9)">如何开通退市交易权限</div>
    </div>

    <div class="questionDiv" >
      <div class="title">
        股票交易
        <!-- <img class="toggleImg" src="images/3.0/more.png"> -->
      </div>
      <div class="question"  @click="goDetail(10)">开盘价是什么</div>
      <div class="question" @click="goDetail(11)">收盘价是什么</div>
      <div class="question" @click="goDetail(12)">股票9:30之前的集合竞价的交易规则是怎样的</div>
      <div class="question" @click="goDetail(13)">股票开市收市时间是怎样的</div>
      <div class="question" @click="goDetail(14)">为什么会有委托价和成交价不一致的情况</div>
      <div class="question" @click="goDetail(15)">股票成交的时间优先、价格优先原则是指什么</div>
      <div class="question" @click="goDetail(16)">市价委托和限价委托的区别是什么</div>
      <div class="question" @click="goDetail(17)">为何委托后一直没有成交</div>
      <div class="question" @click="goDetail(18)">什么情况下可以委托撤单</div>
      <div class="question" @click="goDetail(19)">送股是什么</div>
    </div>
    <div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import  { getAppStorage,callPhone } from '../../service/bridge';
export default {
  methods:
  {
    goDetail(id){
      this.$router.push({
        path: "/helpDetail/"+id
      });
    },call(phone){
      callPhone(phone);
    }
  }
}
</script>
<style>
body {
  height: 100%;
  padding: 0;
  margin: 0;
}
</style>
<style lang="less" >
@import "./style/helpIndex.less";
</style>